import React from 'react'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import ListSubheader from '@material-ui/core/ListSubheader'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { globalSort } from '../../../shared/libraries/sort'
import CustomChip from '../../CustomChip'

const getSelectOptions = ({ options, sorted, ASC }) => {
  if (sorted) {
    return globalSort({
      data: options,
      sortingKey: 'label',
      ASC,
    })
  } else {
    return options
  }
}

/**
 * @param {{className, hasPrimaryText, primaryText, options}} props
 */
export const SelectUnstyled = props => {
  let value = props.input ? props.input.value : null

  if (props.value) {
    value = props.value
  }
  const options = getSelectOptions({
    options: props.options,
    sorted: props.sorted,
    ASC: props.ASC,
  })

  const handleChange = (e, index, value) => {
    return props.onChange
      ? props.onChange(e, index, value)
      : (e, index, value) => props.input.onChange(value)
  }

  return (
    <div className={`${props.className} form-select`}>
      <SelectField
        autoWidth={!!props.autoWidth}
        className="select-field"
        onChange={(e, index, value) => handleChange(e, index, value)}
        value={value}
        iconStyle={{
          fill: 'none',
        }}
        disabled={props.disabled}
        multiple={props.multiple}
        cypress_id={props.cypress_id}
      >
        {props.hasPrimaryText && (
          <MenuItem primaryText={props.primaryText} value={null} />
        )}
        {options.map((option, idx) => {
          if (
            props.multiple &&
            props.listSubheaders.find(
              subHeader => subHeader.value === option.value,
            )
          ) {
            return (
              <ListSubheader disableSticky={true}>{option.label}</ListSubheader>
            )
          }
          return (
            <MenuItem
              key={idx}
              primaryText={
                option.tag ? (
                  <MenuItemLabel label={option.label} tag={option.tag} />
                ) : (
                  option.label
                )
              }
              value={option.value}
              cypress_id={props.cypress_id + '-menu-item'}
            />
          )
        })}
      </SelectField>
      <KeyboardArrowDownIcon fontSize="large" />
    </div>
  )
}

const MenuItemLabel = ({ label, tag = '' }) => {
  return (
    <div>
      {label} {tag ? <CustomChip label={tag} /> : ''}
    </div>
  )
}
